import plupload from "plupload"

const urlParams = new URLSearchParams(window.location.search);
const debug = urlParams.get('debug');

$(function () {
    if ($("#career-app-form").length > 0) {
        initCareerForm()
    }
})

function initCareerForm() {

    var currentUpload = "";

    var uploader = new plupload.Uploader({
        runtimes: "html5",
        browse_button: "pickfiles", //Doesn't matter - Not used, but required in config
        container: document.getElementById('career-app-form'),
        url: "/ajax/uploadFile.php",
        filters: {
            max_file_size: '10mb',
            mime_types: [
                { title: "PDF files", extensions: "pdf" },
                { title: "Word files", extensions: "doc,docx,rtf,txt" }
            ]
        },
        init: {
            PostInit: function () {
                //Nothing to do here
            },

            FilesAdded: function (up, files) {
                //Nothing to do here
            },

            UploadProgress: function (up, file) {
                $("#upload-progress .progress-bar").css("width", file.percent + "%");
            },

            UploadComplete: function (up, file) {
                enableUploadsForm();
            },

            Error: function (up, err) {
                $("#" + currentUpload).val("");
                alert("An error occured while uploading: " + err.message);
                enableUploadsForm();
            }
        }
    })
    uploader.init();

    $(".file-select").change(function (e) {
        currentUpload = $(this).attr("id");
        var field = document.getElementById(currentUpload);

        disableUploadsForm();						//Disable form uploads and submit button
        uploader.splice(0, uploader.files.length);	//Remove any current files
        uploader.addFile(field);					//Add new file to queue

        createUploadProgress().insertAfter($(this));//Create progress bar
        uploader.start();							//Upload files
    })
}

function enableUploadsForm() {
    $(".file-select").removeAttr("disabled");
    $("#send-btn").removeAttr("disabled");
    if (debug !== "true") {
        $("#upload-progress").remove();
    }
}

function disableUploadsForm() {
    $(".file-select").attr("disabled", "disabled");
    $("#send-btn").attr("disabled", "disabled");
}

function createUploadProgress() {
    return $("<div/>", {
        "id": "upload-progress",
        "class": "progress"
    }).append(
        $("<div/>", {
            "class": "progress-bar",
            "style": "width: 0%"
        })
    );
}